"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import API from "@ym-framework/api-utils";
import _ from "lodash";
import DistributionDialog from "@/components/dialog/DistributionDialog.vue";
import { APIDataSource } from "@/components/grid/data-source";
import { Debounce } from "vue-debounce-decorator";
let VdBindAdmin = class extends Vue {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v7/users")
    );
    this.selectDatas = [];
    this.selectLock = false;
    this.activeName = "first";
    this.searchStr = "";
    this.open_type = "";
    this.rows = [];
    this.selectDepartment = null;
    this.departmentList = [];
    this.departmentProps = {
      value: "id",
      label: "label",
      children: "children",
      emitPath: false,
      checkStrictly: true
    };
    this.roleList = [];
    this.selectedRole = "";
    this.maxDepartmentTags = 3;
    this.selectType = "APPEND";
    this.searchByName = _.debounce((searchStr) => {
      this.searchStr = searchStr != null ? searchStr : "";
      this.gridController.query.current = 1;
      this.updateSearchParams();
      this.gridController.search();
    }, 500);
  }
  created() {
    this.gridController.on("searched", (item) => {
      this.checkItem();
    });
    this.gridController.pagePosition = "dialog";
    this.gridController.size = true;
  }
  mounted() {
  }
  open(_0, _1) {
    return __async(this, arguments, function* (openType, rows, selectDatas = []) {
      this.open_type = openType;
      this.rows = rows;
      this.searchStr = "";
      this.selectDatas = [];
      this.selectDepartment = null;
      this.selectedRole = "";
      this.selectLock = false;
      yield this.getDepartmentTrees();
      yield this.getRoleList();
      this.gridController.query.sort = "asc";
      this.updateSearchParams();
      yield this.gridController.search();
      this._distributionDialog.setOptSpan(16, 8);
      this._distributionDialog.open();
      this.$nextTick(() => {
        for (const item of selectDatas) {
          this._distributionDialog.add(item);
        }
      });
    });
  }
  saved(data) {
    return __async(this, null, function* () {
      let userIds = [];
      for (const item of data) {
        userIds.push(item.id);
      }
      let vdIds = [];
      for (const item of this.rows) {
        vdIds.push(item.oldId);
      }
      try {
        if (this.open_type === "single") {
          yield API.post(`api://base.auth.pro/v1/virtual-desktop-admins`, {
            vdIds,
            userIds,
            isCoverage: true,
            mode: "REPLACE",
            type: "VD"
          });
          this.$message.success(
            this.$t("vdbindadmin.binding_successful")
          );
          this._distributionDialog.close();
          this.$emit("refresh");
        }
        if (this.open_type === "multi") {
          if (this.selectType === "APPEND") {
            yield API.post(`api://base.auth.pro/v1/virtual-desktop-admins`, {
              vdIds,
              userIds,
              isCoverage: false,
              mode: "APPEND",
              type: "VD"
            });
          }
          if (this.selectType === "COVER") {
            yield API.post(`api://base.auth.pro/v1/virtual-desktop-admins`, {
              vdIds,
              userIds,
              isCoverage: true,
              mode: "REPLACE",
              type: "VD"
            });
          }
          if (this.selectType === "DELETE") {
            yield API.post(`api://base.auth.pro/v1/virtual-desktop-admins`, {
              vdIds,
              userIds,
              isCoverage: true,
              mode: "DELETE",
              type: "VD"
            });
          }
          if (this.selectType === "CLEAR") {
            yield API.post(`api://base.auth.pro/v1/virtual-desktop-admins`, {
              vdIds,
              userIds: [],
              isCoverage: true,
              mode: "REPLACE",
              type: "VD"
            });
          }
          this.$message.success(
            this.$t("vdbindadmin.binding_successful")
          );
          this._distributionDialog.close();
          this.$emit("refresh");
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeSelectType(type) {
    if (type === "CLEAR") {
      this._distributionDialog.setSelecterVisible(false);
    } else {
      this._distributionDialog.setSelecterVisible(true);
    }
  }
  getRoleList() {
    return __async(this, null, function* () {
      try {
        const responst = yield API.get("api://base.auth/api/v1/roles");
        this.roleList = responst.data.datas;
        const allRoleItem = {
          "id": "all",
          "name": this.$t("vdbindadmin.all_roles")
        };
        this.roleList.unshift(allRoleItem);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getDepartmentTrees() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        const formatData = (nodes) => {
          nodes.forEach((node) => {
            if (node.children && node.children.length > 0) {
              formatData(node.children);
            } else {
              delete node.children;
            }
          });
          return nodes;
        };
        let response = yield API.get(`api://base.auth/api/v7/departments`);
        const allDepartmentItem = {
          "id": "all",
          "label": this.$t("vdbindadmin.all_departments"),
          "disabled": false
        };
        arr.push(allDepartmentItem);
        const rootDepartment = response.data;
        rootDepartment.disabled = true;
        arr.push(rootDepartment);
        formatData(arr);
        this.departmentList = arr;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  selectItems(items) {
    this.selectDatas = [];
    this.selectDatas = items;
    if (!this.selectLock) {
      let unSelectData = _.differenceWith(
        this.gridController.result.datas,
        items,
        _.isEqual
      );
      for (const item of items) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionDialog.add(_item);
      }
      for (const item of unSelectData) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionDialog.del(_item);
      }
    }
  }
  changed(data) {
    let rows = _.differenceWith(
      this.selectDatas,
      data,
      (selectData, data2) => selectData.guid == data2.id
    );
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, false);
      }
    }
    this.selectLock = false;
  }
  checkItem() {
    let selectDatas = this._distributionDialog.getAll();
    let rows = _.intersectionWith(
      this.gridController.result.datas,
      selectDatas,
      (selectData, data) => selectData.guid == data.id
    );
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
    this.selectLock = false;
  }
  changeSelectRole(value) {
    this.selectedRole = value;
    this.gridController.query.current = 1;
    this.updateSearchParams();
    this.gridController.search();
  }
  changeSelectDepartment(value) {
    this.selectDepartment = value != null ? value : null;
    this.gridController.query.current = 1;
    this.updateSearchParams();
    this.gridController.search();
  }
  getDepartmentDisplay(departments) {
    const names = Array.isArray(departments) ? departments.map((item) => item && item.name ? item.name : "").filter((name) => !!name) : [];
    return {
      names: names.slice(0, this.maxDepartmentTags),
      hasMore: names.length > this.maxDepartmentTags
    };
  }
  updateSearchParams() {
    const conditions = [`userStatus=='0'`];
    if (this.searchStr) {
      conditions.push(
        `(name=='%${this.searchStr}%',account=='%${this.searchStr}%')`
      );
    }
    if (this.selectDepartment !== null && this.selectDepartment !== "" && this.selectDepartment !== void 0 && this.selectDepartment !== "all") {
      conditions.push(`departmentId=='${this.selectDepartment}'`);
    }
    if (this.selectedRole !== null && this.selectedRole !== "" && this.selectedRole !== void 0 && this.selectedRole !== "all") {
      conditions.push(`roleId=='${this.selectedRole}'`);
    }
    this.gridController.query.filter = conditions.join(";");
  }
  getId(account) {
    return account.toString().substring(account.toString().length - 4, account.toString().length);
  }
};
__decorateClass([
  Ref("distributionDialog")
], VdBindAdmin.prototype, "_distributionDialog", 2);
__decorateClass([
  Ref("multipleTable")
], VdBindAdmin.prototype, "_multipleTable", 2);
__decorateClass([
  Debounce(400)
], VdBindAdmin.prototype, "saved", 1);
VdBindAdmin = __decorateClass([
  Component({
    components: {
      UiGrid,
      DistributionDialog
    }
  })
], VdBindAdmin);
export {
  VdBindAdmin as default
};
